import { persianDigitProtoType } from './convert.protoType';

export class Convert {
	//
	static faDigitToEn = (str = '') => {
		return str.replace(/[۰-۹]/g, (num) => persianDigitProtoType[num]);
	};

	static imageToBase64 = (e, cb = () => {}) => {
		if (!e.target.value) return;
		const trimToBase64 = (base64Img) => {
			return base64Img?.replace(/^data:image\/[a-z]+;base64,/, '');
		};

		const size = e?.target?.files[0]?.size || 0;
		const type = e?.target?.files[0]?.type || '';
		const image = e?.target?.files[0];

		const reader = new FileReader();
		reader.onloadend = () => {
			const base64 = trimToBase64(reader.result);
			return cb ? cb(reader.result, base64, { size, type }) : null;
		};
		reader.readAsDataURL(image);
	};

	static newDateToFaDate = (date = new Date()) => {
		let faStringDate = Convert.faDigitToEn(new Date(date).toLocaleDateString('fa-IR'));
		let year = faStringDate.split('/')[0];
		let mount = faStringDate.split('/')[1];
		let day = faStringDate.split('/')[2];
		let faSlashDate = `${year}/${mount.length < 2 ? `0${mount}` : mount}/${day.length < 2 ? `0${day}` : day}`;
		return faSlashDate.replaceAll('/', '');
	};
}
